import { GenericTelemetryTracker } from './GenericTelemetryTracker';
/**
 * @deprecated
 * (Host apps should not remove this tracker from their code yet. We will reach out to you once we are ready to decommision this event in our
 * reliability dashboards ADO: 6249511. Any new usage should be avoided)
 */
export class RenderTracker extends GenericTelemetryTracker {
    constructor(logger, renderTrackerOptions) {
        super("RenderComponentByHost" /* Activity.RenderComponentByHost */, logger, renderTrackerOptions);
    }
}
//# sourceMappingURL=RenderTracker.js.map